import React from 'react';
import * as R from 'ramda';

import './index.scss';

export default function ProgressBar({total, children}) {
    const divisor = total > 0 ? total : R.path([0, 'props', 'value'], children);

    const widths = R.pipe(
        R.map(R.path(['props', 'value'])),
        R.map(R.divide(R.__, divisor)),
        R.map(R.multiply(100))
    )(children);
    const lefts = R.reduce(
        (widths, width) => R.append(R.last(widths) + width, widths),
        [0],
        widths
    );
    const newChildren = R.zipWith(
        (child, props) => R.assoc('props', R.merge(child.props, props), child),
        children,
        R.zipWith((left, width) => ({left, width}), lefts, widths)
    );

    return <div className="pacman-progress-bar">{R.reverse(newChildren)}</div>;
}

function Segment({left, width, color}) {
    return (
        <div
            className={`pacman-progress-bar__segment pacman-progress-bar__${color}`}
            style={{left: `${left}%`, width: `${width}%`}}
        />
    );
}

ProgressBar.Segment = Segment;



// WEBPACK FOOTER //
// ./components/progress_bar/index.js